import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { isExternalLink } from '@core-app/utils/link.util';

@Component({
    selector: 'core-block-open-enrollment-banner',
    templateUrl: './block-open-enrollment-banner.component.html',
    styleUrl: './block-open-enrollment-banner.component.scss',
    standalone: false,
})
export class BlockOpenEnrollmentBannerComponent extends BlockAbstractComponent implements OnInit {
    override ngOnInit() {
        super.ngOnInit();

        this.block.data.styleVariant ??= 'card-overlay';
    }

    get formattedDateRange(): string {
        const from = this.block.data.dateFrom;
        const to = this.block.data.dateTo;

        if (!from && !to) {
            return '';
        }

        if (from && !to) {
            return this.formatDate(from);
        }

        if (!from && to) {
            return this.formatDate(to);
        }

        const dateFrom = new Date(from);
        const dateTo = new Date(to);

        const monthFrom = dateFrom.toLocaleString('default', { month: 'short' });
        const monthTo = dateTo.toLocaleString('default', { month: 'short' });
        const dayFrom = dateFrom.getDate() + 1; // Basic adjustment for UTC/local mismatch often seen in date inputs
        const dayTo = dateTo.getDate() + 1;

        if (monthFrom === monthTo) {
            return `${monthFrom} ${dayFrom}–${dayTo}`;
        }

        return `${monthFrom} ${dayFrom} – ${monthTo} ${dayTo}`;
    }

    private formatDate(dateStr: string): string {
        const date = new Date(dateStr);
        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate() + 1;
        return `${month} ${day}`;
    }

    getBackground() {
        const from = this.block.data.bgColorFrom;
        const to = this.block.data.bgColorTo;

        if (from && to) {
            return `linear-gradient(90deg, ${from} 0%, ${to} 100%)`;
        }

        return 'white';
    }

    isExternalLink(url: string | undefined): boolean {
        return isExternalLink(url);
    }
}
